<template>
  <q-btn
    icon="filter_alt"
    :outline="filtersCount > 0 ? true : false"
    :style="{ 'color': filtersCount > 0 ? 'var(--q-primary)' : '' }"
  >
    <q-badge
      v-if="filtersCount > 0"
      :label="filtersCount"
      color="primary"
      size="xs"
      floating
    />
    <q-menu>
      <q-list>
        <q-item
          class="column"
          clickable
        >
          <span class="text-caption">
            Ownership
          </span>
          <span
            class="text-bold text-uppercase"
            :class="{ 'text-grey': !ownerId }"
          >
            {{ ownerId ? 'Mine' : 'Any' }}
          </span>
          <q-menu
            ref="orderOwnershipMenu"
            anchor="top right"
          >
            <q-list>
              <q-item
                v-for="{ label, value } in ownershipOptions"
                :key="`order-filter-ownership-${value}`"
                clickable
                @click="ownerId = value; $refs.orderOwnershipMenu.hide();"
              >
                <q-item-section>
                  <q-item-label>{{ label }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-item>
        <q-item
          v-if="showStateFilter"
          class="column"
          clickable
        >
          <span class="text-caption">
            State
          </span>
          <span
            class="text-bold text-uppercase"
            :class="{ 'text-grey': !state }"
          >
            {{ stateLabel }}
          </span>
          <q-menu
            ref="orderStateMenu"
            anchor="top right"
          >
            <q-list>
              <q-item
                v-for="{ label, value } in stateOptions"
                :key="value"
                clickable
                @click="state = value; $refs.orderStateMenu.hide();"
              >
                <q-item-section>
                  <q-item-label>{{ label }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-item>
        <q-item
          class="column"
          clickable
        >
          <span class="text-caption">
            Type
          </span>
          <span
            class="text-bold text-uppercase"
            :class="{ 'text-grey': !type }"
          >
            {{ typeLabel }}
          </span>
          <q-menu
            ref="orderTypeMenu"
            anchor="top right"
          >
            <q-list>
              <q-item
                v-for="{ label, value } in TYPE_OPTIONS"
                :key="value"
                clickable
                @click="type = value; $refs.orderTypeMenu.hide();"
              >
                <q-item-section>
                  <q-item-label>{{ label }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-item>
        <q-item
          class="column"
          clickable
        >
          <span class="text-caption">
            Register
          </span>
          <span
            class="text-bold text-uppercase"
            :class="{ 'text-grey': !registerStation }"
          >
            {{ registerStation ? registerStation.name : 'Any' }}
          </span>
          <q-menu
            ref="orderRegisterMenu"
            anchor="top right"
          >
            <q-list>
              <q-item
                v-for="{ label, value } in registerStationOptions"
                :key="`order-filter-register-station-${value && value.id}`"
                clickable
                @click="registerStation = value; $refs.orderRegisterMenu.hide();"
              >
                <q-item-section>
                  <q-item-label>{{ label }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-item>
        <q-item
          class="column"
          clickable
        >
          <span class="text-caption">
            Delivery Location
          </span>
          <span
            class="text-bold text-uppercase"
            :class="{ 'text-grey': !deliveryLocation }"
          >
            {{ deliveryLocation ? deliveryLocation : 'Any' }}
          </span>
          <q-menu
            ref="orderDeliveryLocationMenu"
            anchor="top right"
          >
            <q-list>
              <q-item
                v-for="{ label, value } in deliveryLocationOptions"
                :key="`order-filter-delivery-location-${value}`"
                clickable
                @click="deliveryLocation = value; $refs.orderDeliveryLocationMenu.hide();"
              >
                <q-item-section>
                  <q-item-label>{{ label }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-item>
        <q-item
          class="column"
          clickable
        >
          <span class="text-caption">
            For Showings
          </span>
          <span
            class="text-bold text-uppercase"
            :class="{ 'text-grey': !forShowings }"
          >
            {{ forShowingsLabel }}
          </span>
          <q-menu
            ref="orderShowingsMenu"
            anchor="top right"
          >
            <q-list>
              <q-item
                v-for="{ label, value } in SHOWINGS_OPTIONS"
                :key="`order-filter-showings-${value}`"
                clickable
                @click="forShowings = value; $refs.orderShowingsMenu.hide();"
              >
                <q-item-section>
                  <q-item-label>{{ label }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-item>
        <q-item
          class="column"
          clickable
        >
          <span class="text-caption">
            Sales Channel
          </span>
          <span
            class="text-bold text-uppercase"
            :class="{ 'text-grey': !salesChannel }"
          >
            {{ salesChannelLabel }}
          </span>
          <q-menu
            ref="orderShowingsMenu"
            anchor="top right"
          >
            <q-list>
              <q-item
                v-for="{ label, value } in SALES_CHANNEL_OPTIONS"
                :key="`order-filter-showings-${value}`"
                clickable
                @click="salesChannel = value; $refs.orderShowingsMenu.hide();"
              >
                <q-item-section>
                  <q-item-label>{{ label }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-item>
      </q-list>
    </q-menu>
  </q-btn>
</template>

<script>
const SHOWINGS_OPTIONS = [
  { label: 'Any', value: null },
  { label: 'Current', value: 'current' },
  { label: 'Not Current', value: 'not_current' }
]
const TYPE_OPTIONS = [
  { label: 'Any', value: null },
  { label: 'Donation', value: 'donation' },
  { label: 'Membership', value: 'membership_interval' },
  { label: 'Ticket', value: 'ticket' },
  { label: 'Item', value: 'item' },
  { label: 'Gift Card', value: 'all_gift_cards' },
  { label: 'Online Gift Card', value: 'online_gift_card_purchase' },
  { label: 'Remote Application', value: 'remote_application' },
  { label: 'Voucher', value: 'voucher_purchase' },
  { label: 'Voucher Package', value: 'voucher_package_purchase' }
]
const SALES_CHANNEL_OPTIONS = [
  { label: 'Any', value: null },
  { label: 'Kiosk', value: 'Kiosk' },
  { label: 'Register', value: 'Register' },
  { label: 'Phone', value: 'Phone' },
  { label: 'Invoice', value: 'Invoice' },
  { label: 'QR Code', value: 'QR Code' },
  { label: 'Remote Application', value: 'Remote Application' },
  { label: 'Online', value: 'Online' }
]

export default {
  name: 'OrderTableFilter',
  context: ['currentRegisterClient', 'currentUser'],
  configuration: ['currentSite', 'deliveryLocations', 'registerStations'],
  props: {
    initialState: {
      type: String,
      required: false,
      default: null
    },
    showStateFilter: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits: ['owner-change', 'state-change', 'type-change', 'delivery-location-change', 'register-station-change', 'for-showings-change', 'sales-channel-change'],
  data () {
    return {
      ownerId: (this.initialState === 'open_tab' && this.currentRegisterClient?.registerStation?.registerType?.allowTabOrders)
        ? this.currentUser.id
        : null,
      state: this.initialState,
      type: null,
      registerStation: null,
      deliveryLocation: null,
      deliveryLocationsFilterString: '',
      forShowings: null,
      salesChannel: null
    }
  },
  computed: {
    stateLabel () {
      return _.startCase(this.state) || 'Any'
    },
    typeLabel () {
      return _.startCase(this.type) || 'Any'
    },
    forShowingsLabel () {
      return _.startCase(this.forShowings) || 'Any'
    },
    salesChannelLabel () {
      return _.startCase(this.salesChannel) || 'Any'
    },
    ownershipOptions () {
      return [
        { label: 'Any', value: null },
        { label: 'Mine', value: this.currentUser.id }
      ]
    },
    registerStationOptions () {
      const registerStationOptions = _(this.registerStations.data)
        .filter('isUnarchived')
        .map(registerStation => {
          return {
            label: registerStation.name,
            value: registerStation
          }
        })
        .value()

      return _.concat([{ label: 'Any', value: null }], registerStationOptions)
    },
    deliveryLocationOptions () {
      let deliveryLocationOptions = [{ label: 'Any', value: null }]

      if (!this.deliveryLocations?.data) {
        return deliveryLocationOptions
      }

      deliveryLocationOptions = _.concat(
        deliveryLocationOptions,
        _(this.deliveryLocations.data)
          .sortBy('displayOrder')
          .map(deliveryLocation => {
            return {
              label: deliveryLocation.name,
              value: deliveryLocation.name
            }
          })
          .value()
      )

      if (this.deliveryLocationsFilterString === '' || _.isNil(this.deliveryLocationsFilterString)) {
        return deliveryLocationOptions
      }

      return _.filter(deliveryLocationOptions, deliveryLocation => {
        return deliveryLocation.label.startsWith(this.deliveryLocationsFilterString)
      })
    },
    stateOptions () {
      let stateOptions = [
        { label: 'Any', value: null },
        { label: 'Draft', value: 'draft' },
        { label: 'Open Tabs', value: 'open_tab' },
        { label: 'Phone', value: 'phone' },
        { label: 'Unclaimed Refunds', value: 'unclaimed_refunds' },
        { label: 'Has Notes', value: 'has_notes' },
        { label: 'Booking', value: 'booking' },
        { label: 'Completed', value: 'completed' },
        { label: 'Pending', value: 'pending' },
        { label: 'Upcoming Orders', value: 'upcoming_orders' },
        { label: 'Voided', value: 'voided' },
        { label: 'Partially Voided', value: 'partially_voided' },
        { label: 'Has Issue', value: 'has_issue' }
      ]

      if (!this.$register) {
        stateOptions = _.concat(stateOptions, [
          { label: 'Invoice', value: 'invoice' },
          { label: 'Unpaid Invoice', value: 'unpaid_invoice' }
        ])
      } else if (this.currentRegisterClient?.registerStation?.registerType?.searchOptions.invoice_order_search_enabled) {
        stateOptions = _.concat(stateOptions, [
          { label: 'Invoice', value: 'invoice' },
          { label: 'Unpaid Invoice', value: 'unpaid_invoice' }
        ])
      }

      return stateOptions
    },
    filtersCount () {
      return _.filter([this.ownerId, this.state, this.type, this.registerStation, this.deliveryLocation, this.forShowings, this.salesChannel], filter => !_.isNil(filter)).length
    }
  },
  watch: {
    ownerId: {
      handler () {
        this.$emit('owner-change', this.ownerId)
      },
      immediate: true
    },
    state: {
      handler () {
        this.$emit('state-change', this.state)
      },
      immediate: true
    },
    type: {
      handler () {
        this.$emit('type-change', this.type)
      },
      immediate: true
    },
    deliveryLocation: {
      handler () {
        this.$emit('delivery-location-change', this.deliveryLocation)
      },
      immediate: true
    },
    registerStation: {
      handler () {
        this.$emit('register-station-change', this.registerStation)
      },
      immediate: true
    },
    forShowings: {
      handler () {
        this.$emit('for-showings-change', this.forShowings)
      },
      immediate: true
    },
    salesChannel: {
      handler () {
        this.$emit('sales-channel-change', this.salesChannel)
      },
      immediate: true
    }
  },
  created () {
    _.extend(this, {
      SHOWINGS_OPTIONS,
      TYPE_OPTIONS,
      SALES_CHANNEL_OPTIONS
    })
  },
  methods: {
    filterDeliveryLocationOptions (value, _) {
      this.deliveryLocationsFilterString = value
    },
    setFilters (filters = {}) {
      this.ownerId = filters.ownerId || this.ownerId
      this.state = filters.state || this.state
      this.type = filters.type || this.type
      this.registerStation = filters.registerStation || (filters.registerStationId && _.find(this.registerStations.data, { id: filters.registerStationId })) || this.registerStation
      this.deliveryLocation = filters.deliveryLocation || this.deliveryLocation
      this.forShowings = filters.forShowings || this.forShowings
      this.salesChannel = filters.salesChannel || this.salesChannel
    }
  }
}
</script>
